// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"223":"eb840cb1","461":"37f0cbbf","473":"eb840cb1","483":"eb840cb1","526":"eb840cb1","865":"eb840cb1"}[chunkId] + ".chunk.css";
};